import { useState } from "react";
import moment from "moment";
import { MDBRow } from "mdb-react-ui-kit";
import { Icon } from "@iconify/react";
import { sweetAlertHelper } from "../../../helper/sweetalert.helper";

//primereact
import { InputSwitch } from "primereact/inputswitch";
import { Calendar } from "primereact/calendar";

//component
import ListingTable from "../../../components/modal/listingTable";
import Dropdown from "../../../components/element/dropdown";
import ButtonToggle from "../../../components/element/toggleButton";
import apiServices from "../../../services/api.services";
import ToggleSwitch from "../../../components/element/toggleSwitch";

export default function CategoryListing({
  length,
  start,
  createAble,
  listingData,
  totalRecords,
  displayRecords,
  setSearch,
  setStartDate,
  setEndDate,
  setOrder,
  setLength,
  setStart,
  actionValue,
  handleActionChange,
  setHandleApplyFilter,
  getListing,
}) {
  const actionOptions = ["Wallet Log", "Ticket Log"];
  const [date, setDate] = useState(new Date());

  const handleChange = async (id) => {
    try {
      const response = await apiServices.ServiceCategoryStatusToggle({
        id,
        type: "room_service_categories",
      });
      if (response == 200) {
        // sweetAlertHelper({
        //   title: "Success",
        //   text: "Edit Success",
        //   icon: "success",
        // });
        getListing();
      }
    } catch (ex) {
      const errors = ex.response.data.errors;
      let errorMsg = "";

      if (errors && Object.keys(errors).length > 0) {
        Object.keys(errors).map((item, i) => {
          //   setFieldError(item, errors[item]);
          errorMsg = errors[item];
        });

        sweetAlertHelper({
          title: "Error",
          text: `${errorMsg}`,
          icon: "error",
        });
      }
    }
  };

  const statusBodyTemplate = (options) => {
    return (
      <InputSwitch
        checked={options.status}
        trueValue="Active"
        falseValue="Inactive"
        onChange={(e) => handleChange(options.id)}
      />
    );
  };

  const phoneBodyTemplate = ({ phone }) => {
    if (phone) {
      return (
        <span>
          {phone.countryCode}
          {phone.phoneNumber}
        </span>
      );
    }
  };

  const dateBodyTemplate = ({ lastLoginedAt }) => {
    if (lastLoginedAt) {
      return <span>{moment(lastLoginedAt).format("DD/MM/YYYY")}</span>;
    }
  };

  const actionBodyTemplate = (options) => {
    return (
      <MDBRow className="action-button">
        <div onClick={() => handleActionChange("information", options)}>
          <Icon
            icon="heroicons:clipboard-document-list"
            color="#41B1CD"
            width="25"
            height="25"
          />
        </div>
      </MDBRow>
    );
  };

  // inline edit complete function //
  const onRowEditComplete = async (e) => {
    const payload = {
      type: "room_service_categories",
      id: e.newData.id,
      title: e.newData.title,
    };
    try {
      const response = await apiServices.updateServiceCategory({
        api_name: "room_service_category",
        id: e.newData.id,
        payload: payload,
      });
      if (response) {
        getListing();
        sweetAlertHelper({
          title: "Success",
          text: "Edit Success",
          icon: "success",
        });
      }
    } catch (ex) {}
  };

  const filterDateTemplate = (options) => {
    return (
      <Calendar
        id="range"
        value={date}
        onChange={(e) => {
          setDate(e.value);
          setStartDate(e.value[0]);
          setEndDate(e.value[1]);
          // options.filterCallback(e.value);
        }}
        selectionMode="range"
        readOnlyInput
        showIcon
      />
    );
  };

  const monthlyCheckInBodyTemplate = (options) => {
    return <InputSwitch checked={options.monthly_check_in} disabled />;
  };

  const columns = [
    { selectionMode: "multiple", headerStyle: "3em" },
    { field: "title", header: "Title", editor: true },
    {
      field: "created_at",
      header: "Created At",
      filterElement: filterDateTemplate,
    },
    {
      field: "status",
      header: "Status",
      body: statusBodyTemplate,
    },
    { field: "", body: actionBodyTemplate, headerStyle: "0.5em" },
    // { field: "", rowEditor: true, headerStyle: "1em" },
  ];

  const sortFunction = (event) => {
    const field = event.field.split(".")[0];
  };

  return (
    <div className="listing-container">
      <ListingTable
        title="Room Service Category"
        data={listingData}
        columns={columns}
        createAble={createAble}
        setSearchValue={setSearch}
        setHandleApplyFilter={setHandleApplyFilter}
        setOrder={setOrder}
        length={length}
        start={start}
        setLength={setLength}
        setStart={setStart}
        totalRecords={totalRecords}
        displayRecords={displayRecords}
        onRowEditComplete={onRowEditComplete}
      />
    </div>
  );
}
